(function () {
  const data = {
    energie: {
      title: "Énergie / fatigue",
      intro: "Votre objectif semble être de retrouver plus d’énergie et de réduire une fatigue persistante.",
      scores: [
        { name: "Vitamines classiques", score: 45 },
        { name: "Magnésium seul", score: 55 },
        { name: "Shilajit", score: 90 }
      ],
      rows: [
        ["Vitamines classiques", "Variable", "Moyenne", "Ciblée", "Action fragmentée"],
        ["Magnésium seul", "Oui", "Moyenne", "Nerveuse", "Partiel si la fatigue est globale"],
        ["Shilajit", "Oui", "Élevée", "Globale", "Soutien complet"]
      ],
      analyse: "Les solutions isolées peuvent aider ponctuellement, mais elles ciblent souvent un seul axe. Le Shilajit se distingue par son apport en minéraux biodisponibles et son action plus globale sur l’énergie, la récupération et la vitalité.",
      articles: [
        { label: "Fatigue persistante et énergie", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/fatigue-persistante-optimisez-naturellement-votre-apport-en-oxygene-et-en-nutriments" },
        { label: "Carence en fer", url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/shilajit-soutien-mineral-contre-la-carence-en-fer" },
        { label: "Lire l’article sur les alternatives naturelles", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle" }
      ]
    },

    stress: {
      title: "Stress / sommeil",
      intro: "Votre objectif semble être d’apaiser la pression mentale et de retrouver un meilleur équilibre nerveux.",
      scores: [
        { name: "Ashwagandha", score: 70 },
        { name: "Magnésium seul", score: 60 },
        { name: "Shilajit", score: 85 }
      ],
      rows: [
        ["Ashwagandha", "Oui", "Variable", "Adaptogène", "Effet dépendant du profil"],
        ["Magnésium seul", "Oui", "Moyenne", "Système nerveux", "Action partielle"],
        ["Shilajit", "Oui", "Élevée", "Équilibre global", "Soutien large"]
      ],
      analyse: "En cas de stress ou de fatigue nerveuse, une approche globale est souvent plus pertinente qu’un complément isolé. Le Shilajit peut accompagner l’équilibre minéral, l’énergie et la résistance au stress.",
      articles: [
        { label: "Stress et pression mentale", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-reduire-le-stress-naturellement" },
        { label: "Carence en magnésium", url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/carence-en-magnesium-le-role-cle-du-shilajit" },
        { label: "Lire l’article sur les alternatives naturelles", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle" }
      ]
    },

    immunite: {
      title: "Immunité",
      intro: "Votre objectif semble être de renforcer vos défenses naturelles et votre résistance globale.",
      scores: [
        { name: "Vitamine D seule", score: 65 },
        { name: "Zinc seul", score: 60 },
        { name: "Shilajit", score: 88 }
      ],
      rows: [
        ["Vitamine D seule", "Variable", "Moyenne", "Immunité ciblée", "Dépend du statut initial"],
        ["Zinc seul", "Oui", "Moyenne", "Défenses naturelles", "Risque d’excès si mal dosé"],
        ["Shilajit", "Oui", "Élevée", "Soutien global", "Approche minérale complète"]
      ],
      analyse: "L’immunité dépend rarement d’un seul nutriment. Le Shilajit s’inscrit dans une approche globale grâce à sa richesse minérale et son rôle de soutien de l’équilibre général.",
      articles: [
        { label: "Système immunitaire faible", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-renforcer-naturellement-un-systeme-immunitaire-faible" },
        { label: "Carence en vitamine D", url: "https://pureshilajithimalaya.fr/blogs/shilajit-et-carences-ce-que-la-nature-vous-offre/carence-en-vitamine-d-symptomes-causes-et-solutions-naturelles" },
        { label: "Lire l’article sur les alternatives naturelles", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle" }
      ]
    },

    recuperation: {
      title: "Récupération physique",
      intro: "Votre objectif semble être d’aider votre corps à mieux récupérer après l’effort.",
      scores: [
        { name: "Protéines en poudre", score: 60 },
        { name: "Magnésium seul", score: 55 },
        { name: "Shilajit", score: 87 }
      ],
      rows: [
        ["Protéines en poudre", "Variable", "Moyenne", "Musculaire", "Peut être ultra-transformé"],
        ["Magnésium seul", "Oui", "Moyenne", "Crampes / nerfs", "Ne couvre pas tout"],
        ["Shilajit", "Oui", "Élevée", "Récupération globale", "Soutien polyvalent"]
      ],
      analyse: "La récupération ne dépend pas seulement des protéines. Elle implique aussi les minéraux, l’énergie cellulaire et l’équilibre général. Le Shilajit peut donc être une option plus polyvalente.",
      articles: [
        { label: "Récupération musculaire", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/comment-favoriser-une-recuperation-optimale-selon-la-science" },
        { label: "Testostérone et vitalité", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/testosterone-en-berne-comment-relancer-naturellement-votre-energie" },
        { label: "Lire l’article pilier sur les alternatives naturelles", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle" }
      ]
    },

    concentration: {
      title: "Concentration",
      intro: "Votre objectif semble être de soutenir votre clarté mentale, votre mémoire et votre attention.",
      scores: [
        { name: "Caféine", score: 50 },
        { name: "Vitamine B seule", score: 60 },
        { name: "Shilajit", score: 84 }
      ],
      rows: [
        ["Caféine", "Naturelle mais stimulante", "Rapide", "Stimulation", "Effet court / nervosité"],
        ["Vitamine B seule", "Variable", "Moyenne", "Métabolisme énergétique", "Ciblé"],
        ["Shilajit", "Oui", "Élevée", "Énergie + clarté", "Approche globale"]
      ],
      analyse: "Pour la concentration, les stimulants agissent vite mais brièvement. Le Shilajit s’inscrit davantage dans une logique de soutien durable de l’énergie, des minéraux et de la vitalité mentale.",
      articles: [
        { label: "Concentration mentale", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/concentration-mentale-causes-de-la-perte-dattention-et-solutions-naturelles" },
        { label: "Mémoire et fonctions cognitives", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/memoire-et-fonctions-cognitives-soutenir-naturellement-la-sante-du-cerveau" },
        { label: "Lire l’article sur les alternatives naturelles", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle" }
      ]
    },

    digestion: {
      title: "Digestion",
      intro: "Votre objectif semble être de soutenir votre confort digestif et votre équilibre interne.",
      scores: [
        { name: "Probiotiques classiques", score: 65 },
        { name: "Curcuma seul", score: 55 },
        { name: "Shilajit", score: 82 }
      ],
      rows: [
        ["Probiotiques classiques", "Variable", "Variable", "Microbiote", "Qualité très variable"],
        ["Curcuma seul", "Oui", "Faible sans pipérine", "Inflammation", "Assimilation limitée"],
        ["Shilajit", "Oui", "Élevée", "Équilibre interne", "Soutien global"]
      ],
      analyse: "La digestion dépend du microbiote, mais aussi de l’équilibre minéral et du terrain général. Le Shilajit peut compléter cette approche grâce à son action globale.",
      articles: [
        { label: "Santé digestive et microbiote", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/le-shilajit-et-la-sante-digestive" },
        { label: "Acides fulviques", url: "https://pureshilajithimalaya.fr/blogs/quels-sont-les-bienfaits-du-shilajit/shilajit-et-acides-fulviques-pourquoi-sont-ils-si-puissants-pour-la-sante" },
        { label: "Lire l’article sur les alternatives naturelles", url: "https://pureshilajithimalaya.fr/blogs/le-shilajit-alternative-polyvalente-et-naturelle" }
      ]
    }
  };

  function renderScore(item) {
    return `
      <div class="psh-score-line">
        <div class="psh-score-top">
          <span>${item.name}</span>
          <strong>${item.score}%</strong>
        </div>
        <div class="psh-score-bar">
          <div class="psh-score-fill" style="--score:${item.score / 100}"></div>
        </div>
      </div>
    `;
  }

  function initComparateurs() {
    const comparateurs = document.querySelectorAll(".psh-comparateur");

    comparateurs.forEach(function (comparateur) {
      if (comparateur.dataset.initialized === "true") return;
      comparateur.dataset.initialized = "true";

      const buttons = comparateur.querySelectorAll("[data-comparateur]");
      const result = comparateur.querySelector(".psh-comparateur-result");

      if (!buttons.length || !result) return;

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          const key = button.getAttribute("data-comparateur");
          const item = data[key];

          if (!item) return;

          const rowsHtml = item.rows.map(function (row) {
            return `
              <tr>
                <td>${row[0]}</td>
                <td>${row[1]}</td>
                <td>${row[2]}</td>
                <td>${row[3]}</td>
                <td>${row[4]}</td>
              </tr>
            `;
          }).join("");

          const articlesHtml = item.articles.map(function (article) {
            return `<a href="${article.url}" class="psh-comparateur-link">${article.label}</a>`;
          }).join("");

          result.innerHTML = `
            <div class="psh-comparateur-card psh-compare-result">
                <h3>${item.title}</h3>
                <p>${item.intro}</p>

                <div class="psh-score-box">
                    <h4>Score de compatibilité avec votre besoin</h4>
                    ${item.scores.map(renderScore).join("")}
                </div>
              <div class="psh-table-wrapper">
                <table class="psh-comparateur-table">
                  <thead>
                    <tr>
                      <th>Solution</th>
                      <th>Naturel</th>
                      <th>Absorption</th>
                      <th>Action</th>
                      <th>Limite</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${rowsHtml}
                  </tbody>
                </table>
              </div>

              <div class="psh-comparateur-analyse">
                <strong>Analyse des solutions adaptées :</strong>
                <p>${item.analyse}</p>
              </div>

              <div class="psh-comparateur-links">
                <strong>Approfondir votre solution :</strong>
                ${articlesHtml}
              </div>
            </div>
          `;
          setTimeout(function () {
            const fills = result.querySelectorAll(".psh-score-fill");

            fills.forEach(function (fill, index) {
              setTimeout(function () {
                  fill.classList.add("is-visible");
              }, index * 250);
            });
          }, 1000);

          const yOffset = -120;
          const y = result.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: "smooth"
          });
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initComparateurs);
  } else {
    initComparateurs();
  }
})();